import $ljvjO$intlmenuarAEmjs from "../intl/menu/ar-AE.mjs";
import $ljvjO$intlmenubgBGmjs from "../intl/menu/bg-BG.mjs";
import $ljvjO$intlmenucsCZmjs from "../intl/menu/cs-CZ.mjs";
import $ljvjO$intlmenudaDKmjs from "../intl/menu/da-DK.mjs";
import $ljvjO$intlmenudeDEmjs from "../intl/menu/de-DE.mjs";
import $ljvjO$intlmenuelGRmjs from "../intl/menu/el-GR.mjs";
import $ljvjO$intlmenuenUSmjs from "../intl/menu/en-US.mjs";
import $ljvjO$intlmenuesESmjs from "../intl/menu/es-ES.mjs";
import $ljvjO$intlmenuetEEmjs from "../intl/menu/et-EE.mjs";
import $ljvjO$intlmenufiFImjs from "../intl/menu/fi-FI.mjs";
import $ljvjO$intlmenufrFRmjs from "../intl/menu/fr-FR.mjs";
import $ljvjO$intlmenuheILmjs from "../intl/menu/he-IL.mjs";
import $ljvjO$intlmenuhrHRmjs from "../intl/menu/hr-HR.mjs";
import $ljvjO$intlmenuhuHUmjs from "../intl/menu/hu-HU.mjs";
import $ljvjO$intlmenuitITmjs from "../intl/menu/it-IT.mjs";
import $ljvjO$intlmenujaJPmjs from "../intl/menu/ja-JP.mjs";
import $ljvjO$intlmenukoKRmjs from "../intl/menu/ko-KR.mjs";
import $ljvjO$intlmenultLTmjs from "../intl/menu/lt-LT.mjs";
import $ljvjO$intlmenulvLVmjs from "../intl/menu/lv-LV.mjs";
import $ljvjO$intlmenunbNOmjs from "../intl/menu/nb-NO.mjs";
import $ljvjO$intlmenunlNLmjs from "../intl/menu/nl-NL.mjs";
import $ljvjO$intlmenuplPLmjs from "../intl/menu/pl-PL.mjs";
import $ljvjO$intlmenuptBRmjs from "../intl/menu/pt-BR.mjs";
import $ljvjO$intlmenuptPTmjs from "../intl/menu/pt-PT.mjs";
import $ljvjO$intlmenuroROmjs from "../intl/menu/ro-RO.mjs";
import $ljvjO$intlmenuruRUmjs from "../intl/menu/ru-RU.mjs";
import $ljvjO$intlmenuskSKmjs from "../intl/menu/sk-SK.mjs";
import $ljvjO$intlmenuslSImjs from "../intl/menu/sl-SI.mjs";
import $ljvjO$intlmenusrSPmjs from "../intl/menu/sr-SP.mjs";
import $ljvjO$intlmenusvSEmjs from "../intl/menu/sv-SE.mjs";
import $ljvjO$intlmenutrTRmjs from "../intl/menu/tr-TR.mjs";
import $ljvjO$intlmenuukUAmjs from "../intl/menu/uk-UA.mjs";
import $ljvjO$intlmenuzhCNmjs from "../intl/menu/zh-CN.mjs";
import $ljvjO$intlmenuzhTWmjs from "../intl/menu/zh-TW.mjs";

var $bdff4dd8fb5956de$exports = {};


































$bdff4dd8fb5956de$exports = {
    "ar-AE": $ljvjO$intlmenuarAEmjs,
    "bg-BG": $ljvjO$intlmenubgBGmjs,
    "cs-CZ": $ljvjO$intlmenucsCZmjs,
    "da-DK": $ljvjO$intlmenudaDKmjs,
    "de-DE": $ljvjO$intlmenudeDEmjs,
    "el-GR": $ljvjO$intlmenuelGRmjs,
    "en-US": $ljvjO$intlmenuenUSmjs,
    "es-ES": $ljvjO$intlmenuesESmjs,
    "et-EE": $ljvjO$intlmenuetEEmjs,
    "fi-FI": $ljvjO$intlmenufiFImjs,
    "fr-FR": $ljvjO$intlmenufrFRmjs,
    "he-IL": $ljvjO$intlmenuheILmjs,
    "hr-HR": $ljvjO$intlmenuhrHRmjs,
    "hu-HU": $ljvjO$intlmenuhuHUmjs,
    "it-IT": $ljvjO$intlmenuitITmjs,
    "ja-JP": $ljvjO$intlmenujaJPmjs,
    "ko-KR": $ljvjO$intlmenukoKRmjs,
    "lt-LT": $ljvjO$intlmenultLTmjs,
    "lv-LV": $ljvjO$intlmenulvLVmjs,
    "nb-NO": $ljvjO$intlmenunbNOmjs,
    "nl-NL": $ljvjO$intlmenunlNLmjs,
    "pl-PL": $ljvjO$intlmenuplPLmjs,
    "pt-BR": $ljvjO$intlmenuptBRmjs,
    "pt-PT": $ljvjO$intlmenuptPTmjs,
    "ro-RO": $ljvjO$intlmenuroROmjs,
    "ru-RU": $ljvjO$intlmenuruRUmjs,
    "sk-SK": $ljvjO$intlmenuskSKmjs,
    "sl-SI": $ljvjO$intlmenuslSImjs,
    "sr-SP": $ljvjO$intlmenusrSPmjs,
    "sv-SE": $ljvjO$intlmenusvSEmjs,
    "tr-TR": $ljvjO$intlmenutrTRmjs,
    "uk-UA": $ljvjO$intlmenuukUAmjs,
    "zh-CN": $ljvjO$intlmenuzhCNmjs,
    "zh-TW": $ljvjO$intlmenuzhTWmjs
};


export {$bdff4dd8fb5956de$exports as default};
//# sourceMappingURL=intlStrings.mjs.map
